module.exports = __webpack_public_path__ + "public/img/login-picture.896ea157.png";